import axios from "axios";
import React, { useState } from "react";

import { reduxForm, Field } from "redux-form";
import { Grid, Header, Divider, Button } from "semantic-ui-react";
import { renderTextField, renderRadioField } from "../formcomponents";
import { BaseUrl } from "../formcomponents/Constants";
import { userData } from "../store/userData";
const AddExpense = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const [creditorDebit, setcreditorDebit] = useState();
  const userDetail = userData();
  const sumbitForm = (values) => {
    //   private int transationId;
    // private Date transDate;
    // private long balance;
    // private String particulars;
    // private long debit;
    // private long credit;
    // private String transactionNumber;

    const submitObject = {
      transDate: values.transDate,
      balance: values.balance,
      particulars: values.particulars,
      credit: values.credit,
      credit: values.credit,
      transactionNumber: values.transactionNumber,
    };

    console.log(submitObject);
    console.log(values);

    axios
      .post(BaseUrl + "createTransaction", submitObject)
      .then((res) => {
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Add Expense
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <Field
              name="transDate"
              label="Transaction Date"
              type="Date"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            {/* <Field
              name="balance"
              label="Balance"
              type="text"
              component={renderTextField}
            /> */}
          </Grid.Column>
          <Grid.Column>
            <Field
              name="particulars"
              label="Particulars"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <label>Select Credit Or Debit</label>
          </Grid.Column>
          <Grid.Column>
            <Field
              component={renderRadioField}
              label="Debit"
              name="creditOrdebit"
              radioValue="debit"
              onChange={(e) => setcreditorDebit("debit")}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={renderRadioField}
              label="Credit"
              name="creditOrdebit"
              radioValue="credit"
              onChange={(e) => setcreditorDebit("credit")}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <Field
              disabled={creditorDebit === "debit" ? "false" : "true"}
              name="debit"
              label="Debit"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              disabled={creditorDebit === "credit" ? "false" : "true"}
              name="credit"
              label="Credit"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="transactionNumber"
              label="Transaction Number"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      {userDetail.userRole == 1 && (
        <>
          {" "}
          <Button
            type="submit"
            floated="right"
            positive
            disabled={submitting}
            onClick={handleSubmit((values) =>
              sumbitForm({
                ...values,
              })
            )}
          >
            Save
          </Button>
          <Button
            floated="right"
            negative
            disabled={pristine || submitting}
            onClick={reset}
          >
            Cancel
          </Button>{" "}
        </>
      )}
    </div>
  );
};

export default reduxForm({
  form: "AddExpense",
})(AddExpense);
